import _ from 'lodash';
import { createSelector } from 'reselect';
import { matchRoutes } from 'redux-router-kit';

import { RouterSelectors } from '@zapier/toolbox-redux-framework';
import { EDITOR_ROUTE_PATH, TEMPLATE_ROUTE_PATH } from '@zapier/editor-core';

import LoginPreview from 'app/login/components/LoginPreview';
import ServiceLoginPreviewContainer from 'app/explore/components/ServiceLoginPreviewContainer';
import { APPS_INTEGRATIONS_EAGER_ROUTE_PATH } from 'app/explore/constants';

// A routing table with all the routes that should render a "preview" on top of the login/signup form
export const routesWithPreviews = {
  [`/${EDITOR_ROUTE_PATH}/${TEMPLATE_ROUTE_PATH}`]: LoginPreview,
  [`/${APPS_INTEGRATIONS_EAGER_ROUTE_PATH}`]: ServiceLoginPreviewContainer,
};

const selectNextUrl = (state, props) => {
  return _.get(props.router, ['current', 'query', 'next']);
};

export const selectCurrentUrl = state => {
  return RouterSelectors.currentUrl(state);
};

const selectLogin = state => state.login;

const selectLoginPage = state => state.login.loginPage;

const selectLoginPageForm = createSelector(selectLoginPage, ({ form }) => form);

export const selectLoginEmail = createSelector(
  selectLoginPageForm,
  ({ email }) => email
);

export const selectIsSubmitting = state => state.login.loginPage.isSubmitting;

export const selectNextRouteMatchWithZapTemplateId = createSelector(
  selectNextUrl,
  nextUrl => {
    if (!nextUrl) {
      return undefined;
    }

    const match = matchRoutes(routesWithPreviews, nextUrl);

    if (!match) {
      return undefined;
    }

    return match.params.szid;
  }
);

export const hasLastSessionTimedOut = createSelector(
  selectLogin,
  login => login.hasLastSessionTimedOut
);

export const selectSelectedApis = state => {
  const selectedApisParam = RouterSelectors.getQueryParam(
    state,
    'selected_apis'
  );

  if (!selectedApisParam) {
    return [];
  }

  return selectedApisParam.split(',');
};

export const selectUseCaseSlug = state => {
  const useCaseSlugParam =
    RouterSelectors.getQueryParam(state, 'use_case') ||
    RouterSelectors.getQueryParam(state, 'use_case_slug');

  return useCaseSlugParam || '';
};
